import { useConceptos } from '@/modules/cotizaciones/useCotizaciones'
import { pesos } from '@/shared/utilidades/formato'

import estilos from './VistaPreviaAnterior.module.css'

/** Cantidad sin decimales cuando es entera: "17" se lee mejor que "17,00". */
function cantidad(valor: number): string {
  return Number.isInteger(valor) ? String(valor) : valor.toFixed(2).replace('.', ',')
}

/**
 * Qué lleva una cotización anterior, antes de traerla.
 *
 * Traer veintisiete conceptos a ciegas y después quitar los que no eran es más
 * trabajo que buscarlos de nuevo. Se mira primero.
 */
export function VistaPreviaAnterior({ idAsiento }: { idAsiento: number }) {
  const { conceptos, cargando, error } = useConceptos(idAsiento)

  if (cargando) return <p className={estilos.estado}>Cargando los conceptos…</p>
  if (error) return <p className={estilos.error}>{error}</p>
  if (conceptos.length === 0) {
    return <p className={estilos.estado}>Esta cotización llegó sin renglones de detalle.</p>
  }

  return (
    <ul className={`${estilos.lista} desplazable`}>
      {conceptos.map((concepto) => (
        <li
          key={concepto.linea}
          className={concepto.es_mano_de_obra ? estilos.manoDeObra : undefined}
        >
          <span className={estilos.cuantos}>{cantidad(concepto.cantidad)}</span>
          <span className={estilos.nombre}>{concepto.concepto}</span>
          <span className={estilos.valor}>{pesos(concepto.subtotal)}</span>
        </li>
      ))}
    </ul>
  )
}
